import OrganizationInviteItem from './OrganizationInviteItem';

export default OrganizationInviteItem;
